<div class="inline-flex flex-row gap-1 p-1 rounded-lg bg-custom-grey">
    @for (option of options(); track option.value) {
        <app-button
            [customClass]="selectedValueSet().has(option.value) ? '!shadow-sm' : ''"
            [disabled]="!!option.isDisable"
            [label]="option.title"
            [tooltip]="option.tooltip | transloco"
            [type]="selectedValueSet().has(option.value) ? ButtonType.SECONDARY : ButtonType.NEUTRAL"
            (onClick)="toggleOption(option)" />
    }
</div>
